import { createSelector } from '@reduxjs/toolkit';
import { UserRole } from '../../models/user.model';

export const selectAuthState = (state: any) => state.auth;

export const selectIsAuthenticated = createSelector(
  [selectAuthState],
  (auth) => auth.isAuthenticated
);

export const selectIsAdmin = createSelector(
  [selectAuthState],
  (auth) => auth.user.role === UserRole.ADMIN
);

export const selectIsAdminOrOwner = createSelector(
  [selectAuthState],
  (auth) => auth.user.role === UserRole.ADMIN || auth.user.role === UserRole.OWNER
);

export const selectToken = createSelector(
  [selectAuthState],
  (auth) => auth.token
);

export const selectRefreshToken = createSelector(
  [selectAuthState],
  (auth) => auth.refreshToken
);

export const selectUserInfo = createSelector(
  [selectAuthState],
  (auth) => auth.user
);

export const selectSignUpSuccess = createSelector(
  [selectAuthState],
  (auth) => auth.signUpSuccess && !auth.signUpLoading
);

export const selectSignUpLoading = createSelector(
  [selectAuthState],
  (auth) => auth.signUpLoading
);

export const selectSignInSuccess = createSelector(
  [selectAuthState],
  (auth) => auth.signInSuccess && !auth.signInLoading
);

export const selectSignInLoading = createSelector(
  [selectAuthState],
  (auth) => auth.signInLoading
);
